var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "物品id", prop: "itemId", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写物品id" },
                            model: {
                              value: _vm.inputForm.itemId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "itemId", $$v)
                              },
                              expression: "inputForm.itemId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "灵活属性字段",
                            prop: "agileFieldId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写灵活属性字段" },
                            model: {
                              value: _vm.inputForm.agileFieldId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "agileFieldId", $$v)
                              },
                              expression: "inputForm.agileFieldId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "中文名称", prop: "name", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写中文名称" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "英文", prop: "nameEn", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写英文" },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否显示过滤条件",
                            prop: "isShowFilter",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写是否显示过滤条件" },
                            model: {
                              value: _vm.inputForm.isShowFilter,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "isShowFilter", $$v)
                              },
                              expression: "inputForm.isShowFilter",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "序号", prop: "sort", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写序号" },
                            model: {
                              value: _vm.inputForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "sort", $$v)
                              },
                              expression: "inputForm.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "扩展数据(图片数据)",
                            prop: "jsonStr",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写扩展数据(图片数据)" },
                            model: {
                              value: _vm.inputForm.jsonStr,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "jsonStr", $$v)
                              },
                              expression: "inputForm.jsonStr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "描述",
                            prop: "description",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写描述" },
                            model: {
                              value: _vm.inputForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "description", $$v)
                              },
                              expression: "inputForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注信息",
                            prop: "remarks",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写备注信息" },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否询价单供应商必填",
                            prop: "isSupplierRequired",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写是否询价单供应商必填",
                            },
                            model: {
                              value: _vm.inputForm.isSupplierRequired,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "isSupplierRequired",
                                  $$v
                                )
                              },
                              expression: "inputForm.isSupplierRequired",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否询价单供应商显示",
                            prop: "isSupplierDisplay",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写是否询价单供应商显示",
                            },
                            model: {
                              value: _vm.inputForm.isSupplierDisplay,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "isSupplierDisplay",
                                  $$v
                                )
                              },
                              expression: "inputForm.isSupplierDisplay",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否询价单禁止填写",
                            prop: "isSupplierCannotInput",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写是否询价单禁止填写" },
                            model: {
                              value: _vm.inputForm.isSupplierCannotInput,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "isSupplierCannotInput",
                                  $$v
                                )
                              },
                              expression: "inputForm.isSupplierCannotInput",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否必填",
                            prop: "isRequired",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写是否必填" },
                            model: {
                              value: _vm.inputForm.isRequired,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "isRequired", $$v)
                              },
                              expression: "inputForm.isRequired",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "属性注解", prop: "note", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写属性注解" },
                            model: {
                              value: _vm.inputForm.note,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "note", $$v)
                              },
                              expression: "inputForm.note",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }